var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.showHeader
        ? _c("header-bar", {
            staticClass: "header",
            on: {
              changeHelp: _vm.changeHelp,
              closeHelpDoc: _vm.closeHelpDoc,
              xiaoyiStatus: _vm.xiaoyiStatus,
            },
          })
        : _vm._e(),
      _vm.showHeader ? _c("change-product") : _vm._e(),
      _vm.showHomes ? _c("homes", { staticClass: "header" }) : _vm._e(),
      _c(
        "div",
        {
          staticClass: "page-inner",
          style: _vm.showHeader ? "padding-top: 60px" : "",
        },
        [
          _c("router-view", { staticClass: "page" }),
          _vm.$route.path != "/" && _vm.$util.judgeOrigin() == "DF"
            ? _c("div", [_vm.showFooter ? _c("footer-bar") : _vm._e()], 1)
            : _vm._e(),
          _c("help-center", { ref: "helpCenterRef" }),
        ],
        1
      ),
      _vm.allowXy
        ? _c(
            "div",
            [
              _vm.currentShowChat
                ? _c("chat-view", { ref: "chatView" })
                : _vm._e(),
              _vm.currentShowChat
                ? _c("chat-img", { on: { openChat: _vm.openChat } })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c("user-feedback", { ref: "userFeedback" }),
      _vm.showFooter && _vm.$util.judgeOrigin() === "DF"
        ? _c("heart-beat", {
            ref: "heartBeat",
            attrs: { showFooter: _vm.showFooter },
            on: { inactive: _vm.inactive },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }